import { AppBaseData } from '@src/common/app-basic-data';
import { DataResponse } from '@src/common/data-response';
import { DeepReadonly } from '@src/utils/type-utils';
import { makeAutoObservable } from 'mobx';

export class AppBaseStore {
    constructor() {
        makeAutoObservable(this, undefined, { deep: false });
    }

    private _data: DeepReadonly<AppBaseData> | null = null;
    public get data(): DeepReadonly<AppBaseData> | null {
        return this._data;
    }
    public set data(v: DeepReadonly<AppBaseData> | null) {
        this._data = v;
    }

    private _isLoading = true;
    public get isLoading(): boolean {
        return this._isLoading;
    }
    public set isLoading(v: boolean) {
        this._isLoading = v;
    }

    private _error: Error | null = null;
    public get error(): Error | null {
        return this._error;
    }
    public set error(v: Error | null) {
        this._error = v;
    }

    public setDataResponse(value: DataResponse<AppBaseData>) {
        this._data = value.data || null;
        this._isLoading = value.isLoading;
        this._error = value.error || null;
    }

    private _locale = '';
    public get locale(): string {
        return this._locale;
    }
    public set locale(v: string) {
        this._locale = v;
    }

    private _indexScrollPosition = 0;
    public get indexScrollPosition(): number {
        return this._indexScrollPosition;
    }
    public set indexScrollPosition(v: number) {
        this._indexScrollPosition = v;
    }

    private _indexHasTag = 'all';
    public get indexHasTag(): string {
        return this._indexHasTag;
    }
    public set indexHasTag(v: string) {
        this._indexHasTag = v;
    }

    private _indexHasTagScroll = 0;
    public get indexHasTagScroll(): number {
        return this._indexHasTagScroll;
    }
    public set indexHasTagScroll(v: number) {
        this._indexHasTagScroll = v;
    }
}
